import React, { useState } from 'react';
import './Tabs.css';

/**
 * Tabs Component
 *
 * @param {array} tabs - Array of { id, label, icon?, count?, disabled? }
 * @param {string} activeTab - Currently active tab id
 * @param {function} onChange - Tab change handler
 * @param {string} variant - 'default' | 'pills' | 'underline'
 * @param {string} size - 'sm' | 'md' | 'lg'
 */
const Tabs = ({
  tabs = [],
  activeTab,
  onChange,
  variant = 'default',
  size = 'md',
  fullWidth = false,
  className = '',
}) => {
  const [internalActive, setInternalActive] = useState(tabs[0]?.id);

  const currentActive = activeTab !== undefined ? activeTab : internalActive;

  const handleTabClick = (tabId) => {
    if (onChange) {
      onChange(tabId);
    } else {
      setInternalActive(tabId);
    }
  };

  const containerClassNames = [
    'oz-tabs',
    `oz-tabs--${variant}`,
    `oz-tabs--${size}`,
    fullWidth && 'oz-tabs--full-width',
    className
  ].filter(Boolean).join(' ');

  return (
    <div className={containerClassNames} role="tablist">
      {tabs.map((tab) => {
        const isActive = currentActive === tab.id;
        const tabClassNames = [
          'oz-tab',
          isActive && 'oz-tab--active',
          tab.disabled && 'oz-tab--disabled',
        ].filter(Boolean).join(' ');

        return (
          <button
            key={tab.id}
            role="tab"
            aria-selected={isActive}
            aria-disabled={tab.disabled}
            className={tabClassNames}
            onClick={() => !tab.disabled && handleTabClick(tab.id)}
            disabled={tab.disabled}
          >
            {tab.icon && <span className="oz-tab__icon">{tab.icon}</span>}
            <span className="oz-tab__label">{tab.label}</span>
            {tab.count !== undefined && (
              <span className="oz-tab__count">{tab.count}</span>
            )}
          </button>
        );
      })}
    </div>
  );
};

export default Tabs;
